import * as React from 'react'

function CuracoFlag2(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 54 36" {...props}>
      <path fill="#002b7f" d="M0 0h54v36H0z" />
      <path d="M0 22.5h54V27H0z" fill="#f9e814" />
      <g fill="#fff" id="prefix__d">
        <g id="prefix__c">
          <g id="prefix__b">
            <path d="M12 8v4h2z" transform="rotate(18 12 8)" id="prefix__a" />
            <use xlinkHref="#prefix__a" x={-24} transform="scale(-1 1)" />
          </g>
          <g id="prefix__b">
            <path d="M12 8v4h2z" transform="rotate(18 12 8)" id="prefix__a" />
            <use xlinkHref="#prefix__a" x={-20} transform="scale(-1 1)" />
          </g>
          <use xlinkHref="#prefix__b" transform="rotate(72 12 12)" />
        </g>
        <use xlinkHref="#prefix__b" transform="rotate(-72 12 12)" />
        <use xlinkHref="#prefix__c" transform="rotate(144 12 12)" />
      </g>
    </svg>
  )
}

const MemoCuracoFlag2 = React.memo(CuracoFlag2)
export default MemoCuracoFlag2
